// import { Button, Modal } from 'bootstrap/dist/js/bootstrap.bundle';
import React from 'react';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import taskimage from '../../../../assets/img/taskimg.png';
import whyjoin from '../../../../assets/img/why-join.png';
import protection from '../../../../assets/img/protection.png';
import { BiTimeFive } from 'react-icons/bi';
import { MdSecurity, MdOutlinePrivacyTip, MdOutlineSupportAgent, MdOutlineGppGood } from 'react-icons/md';
import { TbAsteriskSimple } from 'react-icons/tb';
import { AiFillLock, AiOutlineStar } from 'react-icons/ai';
import { RiHandCoinLine } from 'react-icons/ri';
import { useState } from 'react';


const RelationshipPartner = () => {

    const [showMore, setShowMore]=useState(false);

    const toggleShowMore=() => {
        setShowMore(!showMore);
    };

    return (
        <React.Fragment>
            <Header />
            <section className='p-0'>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Relationship  </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Relationship</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <section className='logo-designing'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className='logo-designing-title'>
                                <h3>Relationship tasks</h3>
                                <p>Check out what tasks people want done near you right now...</p>
                            </div>
                            <div className='logo-desingning-tasks'>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>
                                    <div className='col-lg-4 col-md-6 col-sm-6 col-12'>
                                        <Card>
                                            <Card.Body>
                                                <div className='tasks-title'>
                                                    <Card.Title>GST</Card.Title>
                                                    <Link className='task-link' to='/'>
                                                        <p>Get this job</p>
                                                    </Link>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-text'>
                                                        <img src={taskimage} alt='' className='img-fluid rounded-circle' to='' />
                                                        <h5>GST</h5>
                                                        <h6>$ 60</h6>
                                                    </div>
                                                </div>
                                                <div className='card-text'>
                                                    <div className='task-time'>
                                                        <BiTimeFive color='#bbc2dc' />
                                                        <h5>about 2 hours ago</h5>
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    </div>

                                </div>
                                <div className='row mt-3'>
                                    <div className='col-lg-12 col-md-12 col-sm-12 col-12'>
                                        <div className='browsetask-btn mt-4'>
                                            <Link type="submit" className="btn btn-primary" to='/'>Browse all tasks</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='why-join'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                            <div className='why-join-title'>
                                <h3>Why join Taskde?</h3>
                                <p>Here are few great reasons</p>
                            </div>
                            <div className='why-join-desc'>
                                <div>
                                    <div className='why-join-desc-input'>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill='#264796'><path d="M20,3.59H16.75V2.66a.75.75,0,1,0-1.5,0v.93H8.75V2.66a.75.75,0,1,0-1.5,0v.93H4A2.75,2.75,0,0,0,1.25,6.34v13A2.75,2.75,0,0,0,4,22.09H20a2.75,2.75,0,0,0,2.75-2.75v-13A2.75,2.75,0,0,0,20,3.59ZM4,5.09H7.25V6.16a.75.75,0,0,0,1.5,0V5.09h6.5V6.16a.75.75,0,0,0,1.5,0V5.09H20a1.25,1.25,0,0,1,1.25,1.25V8.59H2.75V6.34A1.25,1.25,0,0,1,4,5.09ZM21.25,19.34A1.25,1.25,0,0,1,20,20.59H4a1.25,1.25,0,0,1-1.25-1.25V10.09h18.5Z"></path><path d="M8,16.84a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,8,16.84Zm0-3.5a1,1,0,1,1-1,1A1,1,0,0,1,8,13.34Z"></path></svg>
                                        <h3 className='ms-2'>Diverse Offerings</h3>
                                    </div>
                                    <p>Gain access to a rich tapestry of services, from specialized astrology insights to transformative healing sessions, tailored to cater to your unique needs and aspirations.</p>
                                </div>
                                <div>
                                    <div className='why-join-desc-input'>
                                        <MdSecurity fill='#264796' style={{ width: '24px', height: '24px' }} />
                                        <h3 className='ms-2'>Expert Guidance</h3>
                                    </div>
                                    <p>Connect with a community of seasoned professionals committed to delivering exceptional results and fostering your personal and professional growth.</p>
                                </div>
                                <div>
                                    <div className='why-join-desc-input'>
                                        <TbAsteriskSimple fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                        <h3 className='ms-2'>Seamless Experience</h3>
                                    </div>
                                    <p>Enjoy a user-friendly interface and streamlined processes, ensuring a hassle-free journey from discovery to completion of services.</p>
                                </div>
                                <div>
                                    <div className='why-join-desc-input'>
                                        <AiFillLock fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                        <h3 className='ms-2'>Secure Transactions</h3>
                                    </div>
                                    <p>Rest assured that all transactions are secure and reliable, providing you with peace of mind and fostering a trustworthy environment.</p>
                                </div>

                                {showMore&&(
                                    <>
                                        <div>
                                            <div className='why-join-desc-input'>
                                                <MdOutlineSupportAgent fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                <h3 className='ms-2'>Community Support</h3>
                                            </div>
                                            <p>Join a supportive and vibrant community that values collaboration, growth, and mutual success, fostering an environment where your voice is heard and your goals are supported.
                                            </p>
                                        </div>
                                        <div>
                                            <div className='why-join-desc-input'>
                                                <MdOutlineGppGood fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                <h3 className='ms-2'>Elevated Well-being </h3>
                                            </div>
                                            <p>Experience an array of offerings dedicated to enhancing your overall well-being, making your journey towards self-improvement and success as smooth and impactful as possible.</p>
                                        </div>
                                        <div>
                                            <div className='why-join-desc-input'>
                                                <RiHandCoinLine fill='#264796' style={{ width: '24px', height: '24px', color: '#264796' }} />
                                                <h3 className='ms-2'>Lucrative Earnings</h3>
                                            </div>
                                            <p>Leverage our platform to maximize your earnings, with a fair and transparent system that ensures you are duly rewarded for your expertise and efforts.
                                            </p>
                                        </div>
                                    </>
                                )}
                                <div className='show-more-wrapper'>
                                    <button onClick={toggleShowMore} className='show-more-less'>
                                        {showMore? 'Show Less -':'Show More +'}
                                    </button>
                                </div>
                            </div>
                            <div className='why-join-btn'>
                                <Link className="becometasker scrollto" to="/signup">Join Taskde</Link>
                            </div>
                        </div>
                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                            <div className='why-join-img'>
                                <img src={whyjoin} className='img-fluid' alt='' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='protection'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-7 col-md-7 col-sm-12 col-12'>
                            <div className='protection-img'>
                                <img src={protection} className='img-fluid' alt='' />
                            </div>
                        </div>
                        <div className='col-lg-5 col-md-5 col-sm-12 col-12'>
                            <div className='protection-title'>
                                <h3>Protection</h3>
                                <p>It’s nice to have a safety net - that’s why we’ve got insurance available to help you do tasks with peace of mind.</p>
                            </div>
                            <div className='protection-desc'>
                                <div className='protection-desc-input'>
                                    <MdOutlinePrivacyTip fill='#264796' style={{ width: '24px', height: '24px' }} />
                                    <h3 className='ms-2'>Public Liability*</h3>
                                </div>
                                <p>Taskde Insurance covers the Tasker for their liability to third parties for personal injury or property damage whilst performing certain task activities</p>
                                <div className='protection-desc-input'>
                                    <AiOutlineStar fill='#264796' style={{ width: '24px', height: '24px' }} />
                                    <h3 className='ms-2'>Top rated insurance</h3>
                                </div>
                                <p>Taskde Insurance is provided by Berkshire Hathaway Specialty Insurance - one of the most reputable and innovative insurance brands</p>
                                <div className='protection-terms'>
                                    <p>*subject to terms and conditions, excess and exclusions applies.</p>
                                </div>
                            </div>
                            <div className='protection-btn'>
                                <Link className="becometasker scrollto" to="/">Learn more</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default RelationshipPartner;